export default function FlightsListBaseController(
    $scope,
    $rootScope,
    $state,
    $q,
    $timeout,
    flightsFactory,
    basketService,
    baseEvents,
    flightsUtils,
    l10nService,
    flightFareService,
    flightsService,
    flightFiltersService,
    flightResultsSortTypes,
) {
    'ngInject';

        activate();
        initWatchers();

        function activate() {
            const module = flightsFactory.getModule();
            const labels = {
                flights: {
                    showDetails: l10nService.localize('See flight details'),
                    hideDetails: l10nService.localize('Hide flight details'),
                },
                trains: {
                    showDetails: l10nService.localize('See train details'),
                    hideDetails: l10nService.localize('Hide train details'),
                },
            };

            flightFiltersService.flightIsSelected = false;
            $scope.flightFareService = flightFareService;
            $scope.composeCompanyLogoUrl = flightsService.getFlightSupplierLogo;

            $scope.selectedFlights = {};

            $scope.labels = labels[module];

            const flightsResponse = flightsFactory.getFlights();

            $scope.flights = _.omit(flightsResponse, 'Recommendations');
            $scope.flights.Recommendations = flightsResponse.Recommendations;

            if (_.isEmpty($scope.flights)) {
                return $state.go('main.' + flightsFactory.getModule() + '.roundtrip');
            }

            $scope.FareTypeTooltips = {
                Standard: l10nService.localize('These fares are typically the most restrictive'),
                Negotiated: l10nService.localize('A Key Travel special fare which may include flexible conditions'),
                Charity: l10nService.localize('A holdable and flexible fare with minimal airline charges for changes or cancellations'),
            };

            $scope.filterBySegmentModel = angular.copy(flightsFactory.params.SegmentFilterData);

            flightsFactory.resetSegmentFilterData();

            $scope.loadMore = loadMore;
            $scope.searchParameters = flightsFactory.params;
        }

        function initWatchers() {
            let isInitialized = false;
            $scope.$watchCollection('searchParameters.filterByGroup', () => {
                if (!isInitialized) {
                    isInitialized = true;
                    return;
                }
                filterBySegment();
            });
            $scope.$on(baseEvents.FLIGHT_CLEAR_FILTERS_ENDED, () => {
                $scope.searchParameters.filterByGroup = [];
                $scope.searchParameters.GroupByPrice = true;
                $scope.searchParameters.SortByType = flightResultsSortTypes.CHEAPEST.value;
            });
            $scope.$on(baseEvents.CLEAR_SEGMENTS, () => $scope.filterBySegmentModel.length = 0);
            $rootScope.$on(baseEvents.FLIGHT_FILTER_SEARCH_ENDED, function() {
                $scope.flights = flightsFactory.getFlights();
            });
        }

        function filterBySegment() {
            const isSelected = $scope.searchParameters.filterByGroup
                && $scope.searchParameters.filterByGroup.length;

            flightFiltersService.flightIsSelected = isSelected;
            if (isSelected) {
                const groups = [];
                $scope.flights.Recommendations.forEach((recommendation) =>
                    recommendation.FlightSegments.forEach((segment) =>
                        segment.FlightGroups.forEach((group) => groups.push(group))));
                const selectedGroups = groups
                    .filter(({FlightGroupHash}) => $scope.searchParameters.filterByGroup.includes(FlightGroupHash))
                    .map(({FlightGroupId}) => FlightGroupId);
                $scope.searchParameters.SegmentFilterData = Array.from(new Set(selectedGroups));
            } else {
                $scope.searchParameters.SegmentFilterData = [];
            }

            flightsFactory.filterBySegment()
                .then(({data: {Recommendations, FilteredTotal}}) => {
                    Object.assign($scope.flights, {Recommendations, FilteredTotal});
                    $rootScope.$broadcast(baseEvents.APPLY_FILTERS);
            });
        }

        function loadMore() {
            flightsFactory.loadMoreFlights();
            $scope.flights = flightsFactory.getFlights();
        }
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/flightsListBaseCtrl.js